
import Chart from 'react-apexcharts';

const ShipmentStatusPieChart = ({ statusWiseData }) => {
    // Ensure statusWiseData is always an array
    const safeStatusWiseData = Array.isArray(statusWiseData) ? statusWiseData : [];

    // Check if all counts are zero
    const isAllZero = safeStatusWiseData.length > 0 && safeStatusWiseData.every(item => item?.count === 0);

    // If all counts are 0 or data is empty, show "No Data"
    const labels = isAllZero || safeStatusWiseData.length === 0
        ? ["No Data"]
        : safeStatusWiseData.map(item => item?.status);

    const series = isAllZero || safeStatusWiseData?.length === 0
        ? [0.01]
        : safeStatusWiseData.map(item => item?.count);

    const options = {
        labels,
        chart: {
            type: 'donut'
        },
        legend: {
            position: 'bottom'
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom'
                    }
                }
            }
        ],
        colors: isAllZero ? ['#d3d3d3'] : ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A078B6', '#FF6666', '#42A5B9'],
        dataLabels: {
            enabled: true
        }
    };

    return (
        <div className="w-full">
            <Chart
                options={options}
                series={series} // Ensures the chart shows even when all values are 0
                type="donut"
                width="100%"
            />
        </div>
    );
}

export default ShipmentStatusPieChart;
